import { FC, ReactNode } from 'react';
import { Heading, Section } from 'components';
import programProcessImage from 'assets/images/program-process.svg';
import programProcessMobileImage from 'assets/images/program-process-mobile.svg';
import S from './LearnMoreSection.Styled';

interface LearnMoreSectionProps {
  backgroundColor?: string;
  title: string;
  text: ReactNode;
}

export const LearnMoreSection: FC<LearnMoreSectionProps> = ({ backgroundColor, title, text }) => {
  return (
    <Section backgroundColor={backgroundColor}>
      <S.Container>
        <S.TextContainer>
          <S.Title>
            <Heading>{title}</Heading>
          </S.Title>
          <S.Text>{text}</S.Text>
        </S.TextContainer>
        <S.ImageContainer>
          <S.Image src={programProcessImage} alt="Πρόγραμμα" />
          <S.MobileImage src={programProcessMobileImage} alt="Πρόγραμμα" />
        </S.ImageContainer>
      </S.Container>
    </Section>
  );
};
